import React from "react";
import { IoLockClosedOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useAuthModal } from "../contextapi/AuthModalContext";
import "./EditorLoginGate.css";

const EditorLoginGate = ({ title = "Mockup Editor" }) => {
  const navigate = useNavigate();
  const { openAuthModal } = useAuthModal();

  return (
    <section className="editor-login-gate">
      <div className="editor-login-gate__container">
        <div className="editor-login-gate__card">
          <div className="editor-login-gate__icon-wrap">
            <IoLockClosedOutline aria-hidden="true" />
          </div>

          <p className="editor-login-gate__eyebrow">{title}</p>
          <h1 className="editor-login-gate__title">Sign in to use this mockup</h1>
          <p className="editor-login-gate__text">
          Please log in or create account before using this mockup. Creating acount is free, no subscriptions. Ever.
          </p>

          <div className="editor-login-gate__actions">
            <button
              type="button"
              className="btn red-btn rounded-3 editor-login-gate__btn"
              onClick={() => openAuthModal("login", { stayOnPage: true })}
            >
              Log in or Sign up
            </button>
            <button
              type="button"
              className="btn grey-btn rounded-3 editor-login-gate__btn"
              onClick={() => navigate(-1)}
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorLoginGate;
